import { memoize, Nullable } from "@ctra/utils";

import { ChartDataSource, ChartData, ISODuration, ChartTimePeriod } from "../typings";

/**
 * Normalizer Base class
 *
 * @note This handles Iframe data as the default case
 */
class Base {
  protected entity: ChartDataSource;

  constructor(source: ChartDataSource) {
    this.entity = source;
  }

  /**
   * Formats the server response to a format we can use
   * @returns
   */
  @memoize
  format({
    zeroRenderingInterval,
    timePeriod
  }: {
    zeroRenderingInterval: Nullable<ISODuration>;
    timePeriod: Nullable<ChartTimePeriod>;
  }): ChartData {
    return { data: this.formatData({ zeroRenderingInterval, timePeriod }), meta: this.formatMetadata() };
  }

  /**
   * Formats the server response data
   * @returns
   */
  @memoize
  formatData({
    zeroRenderingInterval,
    timePeriod
  }: {
    zeroRenderingInterval: Nullable<ISODuration>;
    timePeriod: Nullable<ChartTimePeriod>;
  }): ChartData["data"] {
    return this.entity as unknown as ChartData["data"];
  }

  /**
   * Formats the server response to a format we can use
   * Contains data that we will translate app-side for use by the chart package
   * ...and other extra meta data
   * @returns
   */
  @memoize
  formatMetadata(): ChartData["meta"] {
    return {} as ChartData["meta"];
  }
}

export { Base };
